import { Controller } from '@hotwired/stimulus'

// Admin zone modal: default prefix per zone type ("de" Lyon / "à" Arcachon) and live page teaser.
const DEFAULT_PREFIXES = { primary: 'de', secondary: 'à' }

export default class extends Controller {
  static targets = ['zoneType', 'name', 'prefix', 'preview']

  static values = {
    primaryTemplate: String,
    secondaryTemplate: String,
    prefixPlaceholder: String,
    namePlaceholder: String
  }

  zoneTypeChanged (event) {
    const prefix = DEFAULT_PREFIXES[event.target.value]
    if (prefix && this.hasPrefixTarget) this.prefixTarget.value = prefix
    this.refresh()
  }

  refresh () {
    if (!this.hasPreviewTarget || !this.hasNameTarget) return

    const name = this.nameTarget.value.trim()
    if (!name) {
      this.previewTarget.textContent = ''
      return
    }

    const template = this.selectedZoneType() === 'secondary' ? this.secondaryTemplateValue : this.primaryTemplateValue
    this.previewTarget.textContent = template
      .replace(this.prefixPlaceholderValue, this.prefixTarget.value.trim())
      .replace(this.namePlaceholderValue, name)
  }

  selectedZoneType () {
    return this.zoneTypeTargets.find((input) => input.checked)?.value
  }
}
